class activeLoc {
  constructor(config = {}) {
    this.DWRAbbrev = config.DWRAbbrev || '',
    this.StatName = config.StatName || '',
    this.data = config.data || []
  }

  updateProps(props) {
    this.DWRAbbrev = props.DWRAbbrev;
    this.StatName = props.StatName;
    return this;
  }

  getProps() {
    return {
      DWRAbbrev: this.DWRAbbrev,
      StatName: this.StatName
    }
  }

  generatePopupContent() {
    return `
      <div class="map-popup-title">${this.StatName}</div>
    `;
  }
}
